export default __webpack_public_path__ + "static/media/KFOmCnqEu92Fr1Mu7WxKKTU1Kvnz.dcd0837e.woff2";